var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.wrapperClasses},[_vm._ssrNode("<input"+(_vm._ssrAttr("disabled",_vm.disabled))+" type=\"checkbox\""+(_vm._ssrAttr("checked",_vm.currentChecked))+(_vm._ssrAttr("value",_vm.inputValue))+(_vm._ssrClass(null,_vm.inputClasses))+"> "),_vm._ssrNode("<span"+(_vm._ssrClass(null,_vm.innerClasses))+">","</span>",[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb857728","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/checkbox/checkbox.vue
// module id = 374
// module chunks = 0 1 4 6 30